import styled from 'styled-components';

export const Screenshot = styled.img`
	max-width: 100%;
	max-height: 100%;
	border-radius: 8px;
`;
